import type { IUseCase } from 'shared-kernel';
import type { ITwoFactorRepository } from '../../../domain/ports';

export interface Activate2FAInput {
  idUtilisateur: string;
  methode: 'EMAIL' | 'APPLICATION';
  codeVerification: string;
  secretTOTP?: string;
}

export class Activate2FAUseCase implements IUseCase<Activate2FAInput, string[]> {
  constructor(
    private readonly twoFactorRepository: ITwoFactorRepository,
  ) {}

  async execute(input: Activate2FAInput): Promise<string[]> {
    const response = await this.twoFactorRepository.activate({
      idUtilisateur: input.idUtilisateur,
      methode: input.methode,
      codeVerification: input.codeVerification,
      secretTOTP: input.secretTOTP,
    });

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Echec de l\'activation 2FA');
    }

    return response.data.codesBackup;
  }
}
